import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input, Toggle } from "@ts-digital/vrc";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import numeral from "numeral";
import React, { memo, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { updateUsedGoodsDetail } from "../../../../../store/actions/usedGoods";
import { VaporDatePicker } from "../../../../vapor";

const FormBuy = memo(({accessoryExpense, currency, draftId, goodsId, onCloseDrawer, setAccessoryExpense}) => {
  const dispatch = useDispatch();
  const intl=useIntl();
  const [updatedForm, setUpdatedForm] = useState(null);
  const [autosaveTimer, setAutosaveTimer] = useState(null);
  const [minutesPassed, setMinutesPassed] = useState(null);  
  const [isUpdated, setIsUpdated] = useState(false);

  const drawerInfo = useSelector(state => state.precog?.usedGoods?.drawer);
  const usedGoodsList = useSelector(state => state.precog?.usedGoods?.list);
  const isLoading = drawerInfo?.status?.started;
  const isError = drawerInfo?.status?.error;
  const drawerDetail = drawerInfo?.detail;

  useEffect(() => {
    setUpdatedForm({
      "fullDescription": drawerDetail?.fullDescription,
      "amount": drawerDetail?.amount,
      "quantity": drawerDetail?.quantity,
      "purchaseDate": drawerDetail?.purchaseDate,
      "increaseExistingGood": drawerDetail?.increaseExistingGood   
    });
  }, [drawerDetail]);
  
  useEffect(() => {
    if (!updatedForm || JSON.stringify(updatedForm) === JSON.stringify({
      "fullDescription": drawerDetail?.fullDescription,
      "amount": drawerDetail?.amount,
      "quantity": drawerDetail?.quantity,
      "purchaseDate": drawerDetail?.purchaseDate,
      "increaseExistingGood": drawerDetail?.increaseExistingGood   
    })) return; 
    
    if (isUpdated){
      setIsUpdated(false);
      dispatch(updateUsedGoodsDetail(
        draftId, goodsId, updatedForm
      )).then(()=> {
        activeSaveInterval();
        const cloneDetailList = [...usedGoodsList];
        let updatedItemList = cloneDetailList.findIndex(el => el.id === goodsId);
        cloneDetailList[updatedItemList] = {...cloneDetailList[updatedItemList], ...updatedForm};      
      
        dispatch({
          type: "UPDATE_USED_GOODS_DETAIL_SUCCESS",
          payload: cloneDetailList
        });
      })
        .catch(e => {
      
        });
    }

  }, [drawerDetail, updatedForm]);
  
  const activeSaveInterval = () => {    
    clearInterval(autosaveTimer);
    setMinutesPassed(0);
    setAutosaveTimer(setInterval(() => {
      setMinutesPassed(minutesPassed + 1);
    }, 60000));
  };

  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  return isLoading ? (
    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
      <FontAwesomeIcon icon={["far", "spinner"]} style={{
        color: "#0090d1",
        fontSize: "44px",
        cursor: "pointer",
        marginBottom: isError ? "20px" : 0
      }} spin /> 
    </div>
  ) : (
    <div style={{display:"flex", flexDirection: "column", 
      margin: "40px 48px",
      justifyContent: "space-between",
      height: "calc(100% - 50px)"}}>
      <div>      
        <div style={{display: "flex", justifyContent: "space-between"}}>
          <div style={{fontWeight: "bold", fontFamily: "Cairo", 
            fontSize: "16px", color:"#005075"}}>
            <FormattedMessage id="preCog.usedGoods.usedGoodsRegistry" /> 
          </div>
          <div style={{display: "flex", alignItems: "center"}}>
            <Toggle
              onChange={() => {                
                setAccessoryExpense(!accessoryExpense);
              }}
              checked={accessoryExpense}
            />
            <span style={{marginLeft: "8px"}}>
              <FormattedMessage id="preCog.usedGoods.accessoryExpense" /> 
            </span>
          </div>
        </div>
        <div style={{marginTop: "21px", color: "#005075", 
          fontWeight: "600", fontFamily: "Cairo", fontSize: "16px",
          lineHeight: "24px", letterSpacing: "0.11px" }}>
          <FormattedMessage id="preCog.usedGoods.identificationData" /> *
        </div>
        <div style={{display: "flex", marginTop: "21px"}}>
          <div style={{width: "51%", borderRight: "1px solid #c9d9e8", paddingRight: "24px"}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div style={{
                fontFamily: "Cairo",
                fontSize: "16px",
                fontWeight: 600,
                color: "#152935"
              }}
              >{updatedForm?.articleDesc}</div>
              <div>
                <div style={{
                  fontFamily: "Cairo",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#152935"
                }}>{numeral(updatedForm?.amount).format("0,0.00")}{currency}</div>
                <div style={{
                  fontFamily: "Cairo",
                  fontSize: "12px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  color: "#5a6872"
                }}>Costo</div>
              </div>
            </div>
            <div style={{marginTop: "42px"}}>
              <div style={{fontSize: "14px", fontWeight: 500, color: "#152935"}}>
                <FormattedMessage id="preCog.usedGoods.idCode" /> 
              </div>
              <div>
                <Input value={updatedForm?.idCode} onChange={
                  (value) => {
                    const cloneUpdatedForm = {...updatedForm};
                    cloneUpdatedForm["idCode"] = value;
                    setUpdatedForm(cloneUpdatedForm);     
                    setIsUpdated(true);           
                  }
                }  />
              </div>
            </div> 
          </div>
          <div style={{display: "flex"}}>
            <div style={{margin: "16px"}}>
              <div style={{fontSize: "14px", fontWeight: 500, color: "#152935"}}>
                <FormattedMessage id="preCog.usedGoods.quantity" /> 
              </div>
              <div>
                <Input value={updatedForm?.quantity} 
                  onChange={
                    (value) => {
                      const cloneUpdatedForm = {...updatedForm};
                      cloneUpdatedForm["quantity"] = value;
                      setUpdatedForm(cloneUpdatedForm);      
                      setIsUpdated(true);          
                    }
                  }  />
              </div>
            </div> 
            <div style={{margin: "16px"}}>
              <div style={{fontSize: "14px", fontWeight: 500, color: "#152935"}}>
                <FormattedMessage id="preCog.usedGoods.buyDate" /> 
              </div>
              <div>
                <VaporDatePicker
                  format={dateFormatList}
                  disabled={true}
                  getPopupContainer={(trigger) => trigger.parentNode}                
                  allowClear={true}
                  className="date-search"
                  value={moment(updatedForm?.purchaseDate)}  
                  onChange={
                    (value) => {
                      const cloneUpdatedForm = {...updatedForm};
                      cloneUpdatedForm["purchaseDate"] =value;
                      setUpdatedForm(cloneUpdatedForm);                
                    }
                  }              
                />
              </div>
            </div> 
          </div>
        </div>
        <div style={{marginTop: "24px"}}>
          <div style={{fontSize: "14px", fontWeight: 500, color: "#152935"}}>
            <FormattedMessage id="preCog.usedGoods.description" /> 
          </div>
          <div>
            <TextArea 
              className="vaporTextarea"
              value={updatedForm?.fullDescription} 
              onChange={
                (e) => {
                  const cloneUpdatedForm = {...updatedForm};
                  cloneUpdatedForm["fullDescription"] = e.target.value;
                  setUpdatedForm(cloneUpdatedForm);        
                  setIsUpdated(true);        
                }
              }
            />
          </div>
        </div>
      </div>
      <div style={{alignSelf: "flex-end"}}>
        <span style={{marginRight: "16px"}}>
          {minutesPassed === 0 ? intl.formatMessage({id: "saved"}) + " " + intl.formatMessage({id: "preCog.bottomBar.saveTime"}) : minutesPassed ? `${intl.formatMessage({id: "saved"})} ${minutesPassed} ${minutesPassed === 1 ? intl.formatMessage({id: "minute"}) : intl.formatMessage({id: "minutes"})} ${intl.formatMessage({id: "ago"})}` : ""}
        </span>
        <Button kind="primary" onClick={() => onCloseDrawer()}>
          <FormattedMessage id="preCog.close" />          
        </Button>
      </div>
    </div>
  );
});

export default FormBuy;
